import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewEncapsulation
} from '@angular/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import sideMenuRoute from './side-menu-route';

@Component({
  selector: 'app-react-user-form',
  template: `<div id="react-user-form-root"></div>`,
  encapsulation: ViewEncapsulation.None
})
export class SideMenuWrapperComponent implements AfterViewInit, OnDestroy {
  rootId = 'react-user-form-root';

  ngAfterViewInit(): void {
    const container = document.getElementById(this.rootId);
    if (container) {
      ReactDOM.render(React.createElement(sideMenuRoute), container);
    }
  }

  ngOnDestroy(): void {
    const container = document.getElementById(this.rootId);
    if (container) {
      ReactDOM.unmountComponentAtNode(container);
    }
  }
  
}